import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "New_in_league",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	enableBackground: "new 0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "new" }), /* @__PURE__ */ _jsx("rect", {
		y: 6,
		width: 16,
		height: 4
	})]
});
export default SvgNew;
